import type { LucideIcon } from 'lucide-react';
import { ListChecks, Printer, Wallet } from 'lucide-react';
import clsx from 'clsx';
import adminIcon from '@/images/apps/admin.svg';
import courierIcon from '@/images/apps/courier.svg';
import menuIcon from '@/images/apps/menu.svg';
import peopleIcon from '@/images/apps/people.svg';
import supplierIcon from '@/images/apps/supplier.svg';
import waiterIcon from '@/images/apps/waiter.svg';
import wholesalerIcon from '@/images/apps/wholesaler.svg';
import { APP_ICON } from '@/data/downloads';

// У продукта — его иконка приложения, у общей темы — нейтральный значок.
const APP_IMAGES: Record<string, string> = {
  admin: adminIcon,
  'admin-app': adminIcon,
  cashier: APP_ICON,
  waiter: waiterIcon,
  'qr-menu': menuIcon,
  people: peopleIcon,
  supplier: supplierIcon,
  wholesaler: wholesalerIcon,
  courier: courierIcon,
};

const TOPIC_GLYPHS: Record<string, LucideIcon> = {
  start: ListChecks,
  billing: Wallet,
  hardware: Printer,
};

interface Props {
  slug: string;
  size: number;
  className?: string;
}

export default function AppIcon({ slug, size, className }: Props) {
  const radius = Math.round(size * 0.24);
  const src = APP_IMAGES[slug];

  if (src) {
    return (
      <img
        src={src}
        alt=""
        width={size}
        height={size}
        draggable={false}
        className={clsx('shrink-0 select-none', className)}
        style={{ width: size, height: size, borderRadius: radius }}
      />
    );
  }

  const Glyph = TOPIC_GLYPHS[slug] ?? ListChecks;
  return (
    <span
      aria-hidden
      className={clsx('grid shrink-0 place-items-center bg-ink/[0.06] text-ink/75', className)}
      style={{ width: size, height: size, borderRadius: radius }}
    >
      <Glyph size={Math.round(size * 0.5)} strokeWidth={1.75} />
    </span>
  );
}
